import { CLEAR_FORM } from 'root/src/client/logic/form/actionIds'

export default payload => ({
	type: CLEAR_FORM,
	payload,
})
